import { useEffect, useState } from "react";
import { Modal } from "antd";
import { useModalCalendar } from "../../../contexts/calendar/ModalCalendarContext.context";
import { EditCalendar } from "./EditCalendar";
import { useCalendars } from "../../../contexts/calendar/CalendarsContext.context";
import { Calendar } from "../../../models/calendar/Calendar.model";
import ConfigurationCalendar from "./ConfigurationCalendar";
import { CreateCalendar } from "./CreateCalendar";

export const ModalCalendar = () => {
    const { setOptions, options } = useModalCalendar();
    const { calendars } = useCalendars();
    const [currentCalendar,setCurrentCalendar] = useState<Calendar>({} as Calendar);
    const [isLoad,setIsLoad] = useState<boolean>(false);
    const cerrar = (isOpen:boolean) =>{
        if(isOpen)return;
        setOptions((prev)=>({
            ...prev,
            isopen:isOpen,
            id:'',
            isCreating:false,
            isConfiguration:false
        }))
    }
    useEffect(() => {
        setIsLoad(false);
        if(options.isEditing||options.isConfiguration){
          const calendar = calendars.find((e) => e.uid === options.id || e.id === options.id);
          if (calendar) {
            setCurrentCalendar(calendar);
            setIsLoad(true);
          }

        }
    }, [options.isEditing,options.id,calendars,options.isConfiguration]);

   if(options.isConfiguration){
      return (<Modal
          title="Configurar Calendario"
          closable={{ 'aria-label': 'Custom Close Button' }}
          width={options.width}
          open={options.isopen}
          onCancel={() => cerrar(false)}
          maskClosable={false}
          footer={null}
          destroyOnHidden={true}
        >
            <div className={`w-${options.width} mt-5`}>
                {isLoad&&<ConfigurationCalendar key={currentCalendar.uid || currentCalendar.id} calendar={currentCalendar}/>}
            </div>
        </Modal>);  
    }else if(options.isEditing){
      return (<Modal
        title="Editar Calendario"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={options.isopen}
        width={options.width}
        onCancel={() => cerrar(false)}
        maskClosable={false}
        footer={null}
        destroyOnHidden={true}
      >
          <div className="w-[475px] mt-6">
                {isLoad&&<EditCalendar key={currentCalendar.uid || currentCalendar.id} calendar={currentCalendar}/>}
          </div>
      </Modal>);
    }else if(options.isCreating){
      return (<Modal
        title="Crear Calendario"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={options.isopen}
        width={options.width}
        onCancel={() => cerrar(false)}
        maskClosable={false}
        footer={null}
        destroyOnHidden={true}
      >
          <div className="w-[475px] mt-6">
                {<CreateCalendar/>}
          </div>
      </Modal>);
    }
    return null;
};